<template>
  <div class="messages form-field-error">
    <span
      v-for="(message, index) in usedMessages"
      :key="index"
      class="error-messages"
    >
      {{ message }}
    </span>
  </div>
</template>
<script setup lang="ts">
interface Props {
  messages: string[];
}
const props = defineProps({
  messages: null
});

const usedMessages = computed(() => {
  if (props.messages.length === 0) {
    return [' '];
  }
  return props.messages;
});
</script>
<style lang="scss" scoped>
.messages {
  display: flex;
  gap: var(--gap_xs);
  min-height: 2rem;
  color: var(--color_error);
}
span:not(:first-child) {
  &::before {
    content: '|';
    padding-right: 0.4rem;
  }
}
</style>
